import axios from 'axios'
import qs from 'qs'
import { notification } from 'ant-design-vue'
import storage from 'store'
import store from '@/store'
import router from '@/router'
import {ACCESS_TOKEN} from "@/store/mutation-types";

const Axios = axios.create()

// Axios请求拦截器
Axios.interceptors.request.use(config => {
  config.url = config.url + '?s=' + new Date().getTime()
  const token = storage.get(ACCESS_TOKEN)
  // 如果 token 存在
  // 让每个请求携带自定义 token 请根据实际情况自行修改
  if (token) {
    config.headers[ACCESS_TOKEN] = token
  }

  if (config.method === 'get') {
    // 处理 GET 请求传递数组参数的情况
    config.paramsSerializer = function(params) {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    }
  }
  return config
})

// 响应拦截器
Axios.interceptors.response.use(
  response => {
    if (response.data.code === 0) {
      return Promise.resolve(response.data)
    } else {
      handlerRequestErr(response.data)
    }
  },
  error => {
    // console.log('--Axios error--', error.response)
    return handlerRequestErr(error.response)
  }
)

function handlerRequestErr(error) {
  const { code, message } = error
  let notifyMsg = '错误'
  switch (code) {
    case 0: notifyMsg = '请求成功'; break
    case 1001: notifyMsg = '参数错误'; break
    case 2001: notifyMsg = '请登录'; break
    case -1: notifyMsg = '请求失败'; break
    case -10: notifyMsg = '请求失败'; break
    default:
  }
  showNotification({ message: notifyMsg, description: message })

  // if (!torage.get(ACCESS_TOKEN)) {
  //   store.commit('emptyAliveComponents')
  //   store.commit('emptyEnums')
  //   store.commit('emptyUser')
  //
  //   showNotification({
  //     message: '无权限 (401)',
  //     description: '没有登录或登录信息已过期，请重新登录！',
  //     duration: null,
  //     btn: h => creatReloginBtn(h),
  //     onClose: handleRelogin
  //   })
  // } else {
  //
  // }

  return Promise.reject(error)
}

function showNotification(data) {
  notification.close('requestError')
  notification.error({
    key: 'requestError',
    ...data
  })
}

function creatReloginBtn(h) {
  return h(
    'a-button',
    {
      props: {
        type: 'primary',
        size: 'small'
      },
      on: { click: handleRelogin }
    },
    '重新登录'
  )
}

function handleRelogin() {
  router.push({ path: '/login' })
  notification.close('requestError')

}

export default Axios
